<template>
    <el-container
        style="width: 60%; margin: 20px auto; padding:20px 0 0 0; border: 1px solid black; background-color: white;">
        <el-header style="text-align: center; font-size: 30px;">{{node.name}}</el-header>
        <el-main>
            <div v-for="(item, index) in questions" :key="index" style="font-size: 20px;">
                <div style="margin-top: 20px;">( {{index+1}} ) {{item.title}}
                </div>
                <div>
                    <div v-if="item.text" style="margin:10px 0 0 0;">&emsp;&emsp;{{item.text}}</div>
                    <div v-if="item.textPic" style="margin:20px 0 0 0; text-align: center;">
                        <img :src="item.textPic" alt="加载失败" style="width: 250px;"></img>
                    </div>
                    <!-- 答案小于10横向, 反之纵向 -->
                    <div>
                        <div v-if="item.answer[0].imgText.length < 10 && item.answer[1].imgText.length < 10 && item.answer[2].imgText.length < 10">
                            <!-- 只有图片作为答案 -->
                            <div
                                v-if="item.answer[0].imgText.length == 0 && item.answer[0].imgSrc.length > 0"
                                style="display:flex; align-items: center;">
                                <div
                                    v-for="(subItem, subIndex) in item.answer"
                                    style="width: 25%;text-align: center;margin:20px 0;">
                                    <img :src="subItem.imgSrc" alt="加载失败" width="100px">
                                        <p>{{alpha[subIndex]}}</p>
                                    </div>
                                </div>
                                <!-- 图片和文字作为答案 -->
                                <div
                                    v-if="item.answer[0].imgText.length > 0 && item.answer[0].imgSrc.length > 0"
                                    style="display: flex; align-items: flex-end;">
                                    <div
                                        v-for="(subItem, subIndex) in item.answer"
                                        style="width: 25%;margin:20px 0; text-align: center;">
                                        <img :src="subItem.imgSrc" alt="加载失败" width="100px">
                                            <p>{{alpha[subIndex]}}. {{subItem.imgText}}</p>
                                        </div>
                                    </div>
                                    <!-- 只有文字作为答案 -->
                                    <div
                                        v-if="item.answer[0].imgText.length > 0 && item.answer[0].imgSrc.length == 0"
                                        style="display: flex; align-items: flex-end;">
                                        <div
                                            v-for="(subItem, subIndex) in item.answer"
                                            style="width: 25%;margin:20px 0;">
                                            {{alpha[subIndex]}}. {{subItem.imgText}}
                                        </div>
                                    </div>
                                </div>
                                <div style="justify-content: center;" v-else="v-else">
                                    <div v-for="(subItem, subIndex) in item.answer" style="margin:20px 0;">{{alpha[subIndex]}}. {{subItem.imgText}}</div>
                                </div>
                            </div>
                        </div>
                        <el-divider></el-divider>
                    </div>
                </el-main>
            </el-container>
        </template>

        <script>
            import data from '../../data/questions.json'
            export default {
                name: "practice",
                data() {
                    return {
                        node: {},
                        alpha: [
                            "A", "B", "C", "D"
                        ],
                        questions: []
                    }
                },
                created() {
                    if (localStorage.getItem('node')) {
                        this.node = JSON.parse(localStorage.getItem('node'));
                    }
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].id == this.node.id) {
                            this.questions = data[i].questions
                        }
                    }
                }
            }
        </script>


// WEBPACK FOOTER //
// src/components/subComponents/practice.vue